var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-ctn"},[_c('div',[_c('a',{attrs:{"href":"https://www.priintr.com/piixme","target":"_blank"}},[_vm._v(_vm._s(_vm.$t("footer.poweredBy")))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }